import { useEffect, useState } from "react";

/* False during the prerender pass AND on the client's first render; true from
 * the first effect onwards.
 *
 * The build snapshots post-effect DOM in a real browser, while hydration
 * renders the pre-effect tree. Anything that swaps ELEMENT STRUCTURE after
 * mount therefore hands React a tree that does not match the HTML it is
 * hydrating — which is what produced the recoverable hydration errors that
 * index.js was quietly swallowing.
 *
 * Gating the structural upgrade on this makes the snapshot and the first
 * client render identical by construction; the upgrade happens a frame later,
 * client-side, where there is nothing to disagree with. */
export function useIsHydrated() {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    // scripts/prerender.py sets this before the page loads, so the snapshot
    // captures the un-upgraded tree.
    if (typeof window !== "undefined" && window.__PRERENDER__) return;
    setHydrated(true);
  }, []);

  return hydrated;
}

export default useIsHydrated;
